<template>
  <div
    id="sidebar"
    class="fixed pin-t pin-r w-full -mr-20 h-screen bg-white z-40 shadow md:w-2/3"
    :class="display ? 'block': 'hidden'"
  >
    <div class="w-full bg-pink-dark p-4 py-12 ">
      <div class="-ml-20 text-center">
        <router-link
          class="no-underline text-teal-lighter text-pink-dark hover:text-pink"
          @click="hideSidebar"
          v-click-outside="hideSidebar"
          :to="{name: 'Profilo'}"
        >
          <img
            class="w-24 h-24 rounded-full border-4 align-middle z-3 relative"
            src="/img/user.png"
          >
          <h3 class="text-white pt-4">
            {{ name }}
          </h3>
        </router-link>
      </div>
    </div>
    <i
      class="fixed pin-t pin-r mt-5 mr-5 fas fa-bars cursor-pointer"
      @click="hideSidebar"
    ></i>
    <ul class="ml-4 p-0">

      <li
        class="block mt-4"
        v-if="checkRole('tutor')"
      >
        <router-link
          class="no-underline text-teal-lighter text-pink-dark hover:text-pink"
          @click="hideSidebar"
          :to="{name: 'Home'}"
        >{{$t('all.home')}}</router-link>
      </li>
      <li class="block mt-4">
        <router-link
          class="no-underline text-teal-lighter text-pink-dark hover:text-pink"
          @click="hideSidebar"
          :to="{name: 'Profilo'}"
        >{{$t('all.edit_profile')}}</router-link>
      </li>
      <li class="block mt-4">
        <router-link
          class="no-underline text-teal-lighter text-pink-dark hover:text-pink"
          @click="hideSidebar"
          :to="{name: 'Login', query: {action: 'logout'}}"
        >{{$t('all.auth_logout')}}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      classe: '',
    };
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        const handler = (e) => {
          if (
            !el.contains(e.target) &&
            el !== e.target &&
            e.target.id !== 'sidebar'
          ) {
            binding.value(e);
          }
        };
        document.addEventListener('click', handler, false);
      }
    },
  },
  computed: {
    ...mapGetters({
      name: 'authentication/name',
    }),
    ...mapGetters({
      display: 'menu/display',
    }),
    className() {
      return this.$route.query.classe;
    }
  },
  methods: {
    ...mapActions('menu', ['hide']),
    hideSidebar() {
      this.hide();
    },
    checkRole(role) {
      return authService.hasRole(role);
    }
  },
};
</script>
